import DefyFormContainer from './defy_form_container';

const DefyForm = DefyFormContainer;
export default DefyForm;
